/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_Terms_Privacy_Privacy_LinkInputs */

const en_consent_terms_privacy_privacy_link = /** @type {(inputs: Consent_Terms_Privacy_Privacy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

const de_consent_terms_privacy_privacy_link = /** @type {(inputs: Consent_Terms_Privacy_Privacy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenschutzerklaerung`)
};

const fr_consent_terms_privacy_privacy_link = /** @type {(inputs: Consent_Terms_Privacy_Privacy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politique de Confidentialite`)
};

const es_consent_terms_privacy_privacy_link = /** @type {(inputs: Consent_Terms_Privacy_Privacy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politica de Privacidad`)
};

const it_consent_terms_privacy_privacy_link = /** @type {(inputs: Consent_Terms_Privacy_Privacy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informativa sulla Privacy`)
};

const nl_consent_terms_privacy_privacy_link = /** @type {(inputs: Consent_Terms_Privacy_Privacy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacybeleid`)
};

const pl_consent_terms_privacy_privacy_link = /** @type {(inputs: Consent_Terms_Privacy_Privacy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polityke Prywatnosci`)
};

const fi_consent_terms_privacy_privacy_link = /** @type {(inputs: Consent_Terms_Privacy_Privacy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tietosuojakaytannon`)
};

const da_consent_terms_privacy_privacy_link = /** @type {(inputs: Consent_Terms_Privacy_Privacy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privatlivspolitikken`)
};

const sv_consent_terms_privacy_privacy_link = /** @type {(inputs: Consent_Terms_Privacy_Privacy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integritetspolicyn`)
};

/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Consent_Terms_Privacy_Privacy_LinkInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consent_terms_privacy_privacy_link = /** @type {((inputs?: Consent_Terms_Privacy_Privacy_LinkInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_Terms_Privacy_Privacy_LinkInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consent_terms_privacy_privacy_link(inputs)
	if (locale === "fr") return fr_consent_terms_privacy_privacy_link(inputs)
	if (locale === "es") return es_consent_terms_privacy_privacy_link(inputs)
	if (locale === "it") return it_consent_terms_privacy_privacy_link(inputs)
	if (locale === "nl") return nl_consent_terms_privacy_privacy_link(inputs)
	if (locale === "pl") return pl_consent_terms_privacy_privacy_link(inputs)
	if (locale === "fi") return fi_consent_terms_privacy_privacy_link(inputs)
	if (locale === "da") return da_consent_terms_privacy_privacy_link(inputs)
	if (locale === "sv") return sv_consent_terms_privacy_privacy_link(inputs)
	return en_consent_terms_privacy_privacy_link(inputs)
});